import { GridOptions, GridApi} from 'ag-grid-community';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { ModuleManager } from 'src/shared/models/module-manager';
import { ContactStateCellRendererComponent } from './contact-state-cell-renderer/contact-state-cell-renderer.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import deepcopy from 'deepcopy';
import { AgGridAngular } from 'ag-grid-angular';

@Component({
    selector: 'cv-contact-list-details',
    templateUrl: './contact-list-details.component.html',
    styleUrls: ['./contact-list-details.component.scss']
})

export class ContactListDetailsComponent implements OnInit {

    @ViewChild('contactListDetailsGrid') agGrid: AgGridAngular;
    @Input() moduleManager: ModuleManager;
    @Input() data;
    @Input() skill;
    @Input() id;
    @Input() agent;

    public gridApi: GridApi;
    filterValue: any;
    rowData = [];
    gridOptions: GridOptions;
    noData = false;

    constructor(
        private agGridHelperService: AgGridHelperService,
        private activeModal: NgbActiveModal,
    ) {
    }

    autoSizeAll(gridApi) {
        const allColumnIds = [];
        gridApi.getColumns().forEach(column => allColumnIds.push(column.getColId()));
        gridApi.autoSizeColumns(allColumnIds);
    }

    ngOnInit(): void {
        if (typeof(this.data) == "undefined" || this.data === null) {
            this.noData = true;
            return;
        }
        else this.noData = false;

        for (let i = 0; i < this.data?.Details.length; i++) {
            const newRow = {
                State: this.data.Details[i].StateName,
                Duration: this.data.Details[i].TotalTimeDisplay,
                Time: this.data.Details[i].StartDateDisplay,
                ModuleName: 'ContactListDetails',
                ContactID: this.data.Details[i].ContactID,
                index: this.data.Details.length - i,
            };
            this.rowData.push(newRow);
        }

        this.gridOptions = this.agGridHelperService.createGridOptions({
            context: { moduleManager: this.moduleManager },
            components: {
                ContactStateCellRenderer : ContactStateCellRendererComponent,
            },

            // grid options
            accentedSort: true,
            animateRows: true,
            suppressCellFocus: true,
            suppressScrollOnNewData: true,
            rowHeight: 40,
            suppressContextMenu: true,
            getMainMenuItems: (params: any) => {
                const menuItems = deepcopy(params.defaultItems);
                return menuItems;
            },
            // external filtering (our search bar)
            isExternalFilterPresent: () => {
                if (this.filterValue === undefined) {
                    return false;
                }
                return this.filterValue.length > 0;},
            doesExternalFilterPass: (node: any) => this.agGridHelperService.doesExternalFilterPass(node, this.filterValue),
            onGridReady: params => {
                this.gridApi = params.api;
                if (this.rowData) {
                    this.gridApi.setGridOption('rowData', this.rowData);
                }
                this.gridApi.setGridOption('domLayout','autoHeight');
                this.gridApi.sizeColumnsToFit();
            },
            onColumnVisible: params => {
                this.gridApi = params.api;
                this.autoSizeAll(this.gridApi);
                this.gridApi.sizeColumnsToFit();
            },
            onGridSizeChanged: params => {
                this.gridApi = params.api;
                this.autoSizeAll(this.gridApi);
                this.gridApi.sizeColumnsToFit();
            },
            // grid data
            columnDefs: [
                {
                    field: 'State',
                    headerName: 'State',
                    filter: 'agTextColumnFilter',
                    cellRenderer: 'ContactStateCellRenderer',
                    cellRendererParams: {showTotals : false},
                    resizable: true, suppressMovable: true,
                    suppressMenu: true
                },
                {
                    field: 'Time',
                    headerName: 'Time',
                    filter: 'agTextColumnFilter',
                    cellRenderer: params => "<div class='d-flex flex-column justify-content-center h-100'>" + params.value + "</div>",
                    resizable: true, suppressMovable: true,
                    suppressMenu: true
                },
                {
                    field: 'Duration',
                    headerName: 'Duration',
                    filter: 'agTextColumnFilter',
                    cellRenderer: params => "<div class='d-flex flex-column justify-content-center h-100'>" + params.value + "</div>",
                    resizable: true, suppressMovable: true,
                    suppressMenu: true
                },
            ],
            rowData: this.rowData,
        },
        {
            enableCopy: true
        });

    }

    close() {
        this.activeModal.close();
    };
}


